/* eslint-disable max-classes-per-file */
import { SelectionItem } from "~app/common/components/tree-selector/selection-item";
import { SelectionEventType } from "~app/common/components/tree-selector/SelectionEventType";
import { ObjectUtils } from "~app/common/utils/object-utils";

export interface IHandelssortimentsgrupp {
    grupp: string;
    gruppId: number;
    hasProduktionsmal: boolean;
    handelssortiment: IHandelssortiment[];
}

export interface IHandelssortiment {
    namn: string;
    relaterarTillHandelssortimentId: number;
    hasProduktionsmal: boolean;
    handelssortimentsgruppNamn: string;
    handelssortimentId: number;
    produkter: IProdukt[];
    aktiv?: boolean;
    selectedInAo?: boolean;
}

export interface IProdukt {
    kvantitet?: number;
    justeradKvantitet?: number;
    namn: string;
    aktiv?: boolean;
    selectedInAo?: boolean;
    produktId: number;
    handelssortimentKategori: string;
    produktinstruktioner: IProduktInstruktion[];
}

export interface IProduktInstruktion {
    medIUtbytessimulering?: boolean;
    produktinstruktionId: number;
    selectedInAo?: boolean;
    aktiv?: boolean;
    namn: string;
    puid: string;
}

export interface IProduktvalRowProduktInstruktion {
    id: number;
    namn: string;
    puid: string;
}

export interface IProduktvalRow {
    handelssortimentId: number;
    handelssortimentsgrupp: string;
    handelssortimentKategori: string;
    hasProduktionsmal: boolean;
    produktId: number;
    produkt: string;
    produktinstruktioner: IProduktvalRowProduktInstruktion[];
    medTillUtbytessimulering?: number;

    kvantitet: number;
    handelssortimentProduktAsText: string;
    hasProdukt: boolean;
    hasPinnar: boolean;
    rowTextAsHTML: string;
    pinText: string;
    simuleradKvantitet: number;
    simuleradKvantitetText: number | string;

    valideringsMeddelande: string;
    namn: string;
    collapsed: boolean;
    justeradKvantitet: number;

    unsetProdukt(): void;
    getSelectionIds(): string[];
    setMedTillUtbytessimulering(newValue: number): void;
    setJusteradKvantitet(newValue: number): void;
    produktinstruktionValueFormatter: (item: IProduktvalRowProduktInstruktion) => number;
    produktinstruktionDisplayValueFormatter: (item: IProduktvalRowProduktInstruktion) => string;
}

export abstract class ProduktvalRowBase implements IProduktvalRow {
    collapsed: boolean;
    handelssortimentsgruppId: number;

    get kvantitet(): number {
        return (!ObjectUtils.isNullOrUndefined(this.justeradKvantitet)) ? this.justeradKvantitet : this.simuleradKvantitet || 0;
    }

    get simuleradKvantitetText(): number | string {
        return this.simuleradKvantitet || "-";
    }

    get handelssortimentProduktAsText(): string {
        if (!this.produkt) {
            return this.namn;
        }
        return `${this.namn}, ${this.produkt}`;
    }

    get rowTextAsHTML(): string {
        let html = "";
        if (!this.produkt) {
            html += this.namn;
        } else {
            html += `${this.namn}, ${this.produkt}<br />`;
        }
        const pins = [];
        // eslint-disable-next-line sonarjs/no-misleading-array-reverse
        this.produktinstruktioner
            .sort((a, b) => a.namn > b.namn ? 1 : -1)
            .forEach(x => {
                if (x.id === this.medTillUtbytessimulering) {
                    pins.push(`<i>${x.namn}</i>`);
                } else {
                    pins.push(`${x.namn}`);
                }
            });
        html += pins.join(", ");
        return html;
    }

    get hasProdukt(): boolean {
        return !!this.produktId;
    }

    get hasPinnar(): boolean {
        return !!this.produktinstruktioner && this.produktinstruktioner.length > 0;
    }

    get pinText(): string {
        return this.produktinstruktioner.map(x => x.namn).join(", ");
    }

    namn: string;
    handelssortimentId: number;
    handelssortimentsgrupp: string;
    handelssortimentGruppId: number;
    handelssortimentKategori: string;
    hasProduktionsmal: boolean;
    produktId: number;
    produkt: string;
    produktinstruktioner: IProduktvalRowProduktInstruktion[];
    medTillUtbytessimulering?: number;
    justeradKvantitet: number;
    simuleradKvantitet: number;

    valideringsMeddelande: string;

    abstract produktinstruktionValueFormatter: (item: IProduktvalRowProduktInstruktion) => number;

    abstract produktinstruktionDisplayValueFormatter: (item: IProduktvalRowProduktInstruktion) => string;

    abstract setMedTillUtbytessimulering(newValue: number): void;

    abstract setJusteradKvantitet(newValue: number): void;

    unsetProdukt(): void {
        this.produktId = undefined;
        this.produkt = undefined;
        this.justeradKvantitet = null;
        this.simuleradKvantitet = null;
        this.medTillUtbytessimulering = undefined;
    }

    getSelectionIds(): string[] {
        const tmp = this.produktinstruktioner.map(pin => `${this.handelssortimentId}:${this.produktId}:${pin.id}`);
        if (this.produktId) {
            tmp.push(`${this.handelssortimentId}:${this.produktId}`);
        }
        tmp.push(`${this.handelssortimentId}`);
        return tmp;
    }
}

export class ProduktvalSelectionItem extends SelectionItem {
    hasProduktionsmal: boolean;
    relaterarTillId: number;
}

export class ProduktSelection {
    constructor(
        public handelssortimentsgruppNamn: string,
        public handelssortiment: IHandelssortiment,
        public produkt?: IProdukt,
        public produktinstruktion?: IProduktInstruktion) {
    }
}

export class ProduktvalEvent {
    row: ProduktSelection;
    selectionEventType: SelectionEventType;
}
